export const SelectType = {
  TYPE: 'type',
  USER: 'user',
  USER_V2: 'userV2',
  TECH_FAMILY: 'techFamily',
  DOMAIN: 'domain',
  BACKEND: 'backend',
  FACET: 'facet',
  COUNTRY: 'country',
  CITY: 'city',
  TAG: 'tag',
  VARIABLE: 'variable',
  PRODUCT_ENTITY: 'productEntity',
  SUBSCRIBED_SERVICES: 'subscribedServices',
} as const;

export type SelectType_Keys = keyof typeof SelectType;
